Vendd.Scripts.load(function () {
    initOwlSlider($('.news-slider > ul'), { singleItem: true, rewindSpeed: 1500 });
    ///initOwlSlider($('.home-page .homepage-slider > ul'), { singleItem: true, rewindSpeed: 1500,  transitionStyle: "fade" });
    initOwlSlider($('.home-page .promo-container-one > ul'), { items: 3, itemsDesktop: [1199, 3], itemsDesktopSmall: [959, 3], itemsTablet: [768, 2], itemsMobile: [479, 1] });
    initOwlSlider($('.category-list-page .caregory-slider > ul'), { items: 5, itemsDesktop: [1199, 4], itemsDesktopSmall: [959, 3], itemsTablet: [768, 2], itemsMobile: [479, 1] });
    initOwlSlider($('.category-list-page2 .caregory-slider > ul'), { items: 5, itemsDesktop: [1199, 4], itemsDesktopSmall: [959, 3], itemsTablet: [768, 2], itemsMobile: [479, 1] });
    initOwlSlider($('.category-list-page .brands-slider > ul'), { items: 5, itemsDesktop: [1199, 3], itemsDesktopSmall: [959, 3], itemsTablet: [768, 2], itemsMobile: [479, 1] });
    initOwlSlider($('.manufacturer-list-page .x-slider > ul'), { items: 5, itemsDesktop: [1199, 5], itemsDesktopSmall: [959, 3], itemsTablet: [768, 2], itemsMobile: [479, 1] });
    initOwlSlider($('.manufacturer-details-page .x-product-slider .x-product-list > ul'), { items: 4, itemsDesktop: [1199, 4], itemsDesktopSmall: [959, 4], itemsTablet: [768, 3], itemsMobile: [479, 2], });
    initOwlSlider($('.product-details-region .x-product-slider .x-product-list > ul'), { items: 5, itemsDesktop: [1199, 5], itemsDesktopSmall: [959, 4], itemsTablet: [768, 3], itemsMobile: [479, 2] });
    initOwlSlider($('.combo-template-two .x-product-slider .x-product-list > ul'), { items: 5, itemsDesktop: [1199, 5], itemsDesktopSmall: [959, 4], itemsTablet: [768, 3], itemsMobile: [479, 2] });
    initOwlSlider($('.category-list-page .x-product-slider .x-product-list > ul'), { items: 5, itemsDesktop: [1199, 4], itemsDesktopSmall: [959, 4], itemsTablet: [768, 3], itemsMobile: [479, 2] });
    initOwlSlider($('.cart-region .x-product-slider .x-product-list > ul'), { items: 5, itemsDesktop: [1199, 5], itemsDesktopSmall: [959, 4], itemsTablet: [768, 3], itemsMobile: [479, 2] });
    initOwlSlider($('.home-page .x-product-slider .x-product-list > ul'), { items: 5, itemsDesktop: [1199, 3], itemsDesktopSmall: [959, 2], itemsTablet: [640, 1], itemsMobile: [479, 1] });
    initOwlSlider($('.blog-details-page .x-product-slider .x-product-list > ul'), { items: 4, itemsDesktop: [1199, 4], itemsDesktopSmall: [959, 4], itemsTablet: [768, 3], itemsMobile: [479, 2] });

    if (!isTouch() || $(window).width() >= 1200) {
        initOwlSlider($('.brand-slider > ul'), { items: 5, itemsDesktop: [1199, 4], itemsDesktopSmall: [959, 4], itemsTablet: [768, 3], itemsMobile: [479, 2] });
        initOwlSlider($('.x-instagram-feed .instagram-list > ul'), { items: 5, itemsDesktop: [1199, 4], itemsDesktopSmall: [959, 3], itemsTablet: [768, 2], itemsMobile: [479, 2], afterMove: function () { setTimeout(function () { $(window).trigger('lazyload'); }, 600); } });
    } else {
        $(".brands-list ").mCustomScrollbar({
            axis: "x",
            theme: "dark-3"
        });
        $(".x-instagram-feed .instagram-list > ul").mCustomScrollbar({
            axis: "x",
            theme: "dark-3"
        });
        $(".category-list-page .category-list-page2 .caregory-slider .banners-list").mCustomScrollbar({
            axis: "x",
            theme: "dark-3"
        });
    }

    $(window).on('resize', function () {

        ww = $(window).width();
        mobile = (ww < 960) ? true : false;

        if (!mobile) {
           initOwlSlider($('.generalCategoryPage-page .x-product-slider .x-product-list > ul'), { items: 5, itemsDesktop: [1199, 4], itemsDesktopSmall: [959, 4], itemsTablet: [768, 3], itemsMobile: [479, 2] });
        } else {      
            destroyOwlSlider($('.generalCategoryPage-page .x-product-slider .x-product-list > ul'));
        }

    });
    // Get the quantity of images (GENERAL CATEGORY PAGE)
    var numberOfImages = $('.categoryPage-slider  > ul > li').length;
    var numberOfImagesList = $('.categoryList-slider  > ul > li').length;
    if (numberOfImages > 1) {
        initOwlSlider($('.generalCategoryPage-page .categoryPage-slider > ul'), { singleItem: true, rewindSpeed: 1500, autoPlay: 5000, stopOnHover: true, transitionStyle: "fade" });
    }
    if (numberOfImagesList > 1) {
        initOwlSlider($('.generalCategoryListPage-page .categoryList-slider > ul'), { singleItem: true, rewindSpeed: 1500, autoPlay: 5000, stopOnHover: true, transitionStyle: "fade" });
    }

});


var defSliderOptions = {
    navigation: true,
    pagination: true,
    items: 3,
    slideSpeed: 600,
    scrollPerPage: true,
    paginationSpeed: 600,
    addClassActive: true,
    navigationText: ["<span class='icon icon-arrow-big-left'></span>", "<span class='icon icon-arrow-big-right'></span>"],
    autoPlay: 5000,
    lazyLoad: false,
   // stopOnHover:true,
    autoHeight: false
};

function initOwlSlider(container, options) {

    if ($(container).length > 0) {

        container.SliderOption = options;

        var $wrapper = $(container).closest('.x-slider');

        if (!$wrapper.data('init'))
            return;

        var opts = $.extend({}, defSliderOptions, options);

        if ($wrapper.data('detailed-pager')) {
            opts.afterUpdate = function () {
                assignPagerValues($wrapper);
            };
            opts.afterInit = function () {
                assignPagerValues($wrapper);
            };
        }

        if ($(container).parent().hasClass("js-lazyload") && typeof $.fn.lazyload === "function") {

            opts.afterMove = opts.afterMove || function () {
                setTimeout(function () { $('img', $wrapper).trigger('lazyload'); }, defOptions.slideSpeed);
            };
            $("img", $wrapper).lazyload().trigger('lazyload');
        }

        container.owlCarousel(opts);
    }
}
function destroyOwlSlider($container) {
    if ($container.length > 1) {
        //for those pages that have more than one product list ex category list page
        $container.each(function () {
            if (typeof $(this).data('owlCarousel') !== 'undefined') {
                $(this).data('owlCarousel').destroy();
                $(this).removeClass('owl-carousel');
            }
        });
    } else {
        if (typeof $container.data('owlCarousel') !== 'undefined') {
            $container.data('owlCarousel').destroy();
            $container.removeClass('owl-carousel');
        }
    }
}
function assignPagerValues(wrapper) {

    if (!wrapper || wrapper.length < 1) return;

    var items = $('> ul > .owl-wrapper-outer > .owl-wrapper > .owl-item', wrapper);
    var pages = $('> ul > .owl-controls > .owl-pagination > .owl-page', wrapper);

    items.each(function (index, item) {
        var $item = $(item),
            value = $('.js-anchor', $item).html();
        $('span', pages.eq(index)).html(value);

    });

}